import React, { useMemo, useCallback } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Dropdown, Menu, Button } from "antd";
import { connect } from "dva";

const MoreMenu = ({ configPerm, items, disabled: disabledProp, children, onItemClick }) => {
  const enabledItems = useMemo(() => {
    return (items || []).filter(item => {
      return item.authority === true || configPerm[item.authority];
    });
  }, [items, configPerm]);

  const disabled = useMemo(() => {
    return disabledProp || enabledItems.length === 0;
  }, [disabledProp, enabledItems.length]);

  const onMenuItemClick = useCallback(
    ({ key }) => {
      if (typeof onItemClick === "function") {
        onItemClick(key);
      }
    },
    [onItemClick],
  );

  const overlay = useMemo(() => {
    return (
      <Menu onClick={onMenuItemClick}>
        {enabledItems.map(item => {
          const { key, icon, label, danger, disabled } = item;
          return (
            <Menu.Item key={key} icon={icon} danger={danger} disabled={disabled}>
              {label}
            </Menu.Item>
          );
        })}
      </Menu>
    );
  }, [enabledItems, onMenuItemClick]);

  if (disabled) {
    return children || <Button icon={<MoreOutlined />} disabled />;
  }

  return (
    <span>
      <Dropdown overlayClassName="moreMenu" trigger={["click"]} overlayStyle={{ minWidth: "100px" }} overlay={overlay}>
        {children || <Button icon={<MoreOutlined />} />}
      </Dropdown>
    </span>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs.configPerm,
}))(MoreMenu);
